module.exports = __webpack_public_path__ + "static/img/su.e55d0ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/su.jpg
// module id = tLtN
// module chunks = 1